import { NgModule, OnInit } from '@angular/core';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { LayoutDefaultComponent } from './components/default.component';
import { LayoutDefaultShellComponent } from './container/default-shell.component';
import { LayoutNoframeComponent } from './components/noframe.component';
import { LayoutShellComponent } from './container/layout-shell.component';
import { NotificationMenuComponent } from './components/notification-menu/notification-menu.component';

@NgModule({
  imports: [
    AppRoutingModule,
    SharedModule
  ],
  declarations: [
    LayoutDefaultComponent,
    LayoutDefaultShellComponent,
    LayoutNoframeComponent,
    LayoutShellComponent,
    NotificationMenuComponent
  ],
  exports: [
    LayoutShellComponent
  ]
})
export class LayoutModule { }
